// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Steps_anchor__3qNS9"};